// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"47e82748","703":"8a6cdb85","787":"399b451b"}[chunkId] + ".chunk.js";
};